import "@expo/metro-runtime";
import { registerRootComponent } from "expo";
import 'react-native-url-polyfill/auto';
import "react-native-get-random-values";
import App from "./app/App";
import "./app/configs/countries-locales";
import "./app/configs/reanimated";

registerRootComponent(App);
